var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', _vm._b({}, 'sub-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('business-intro', _vm._b({}, 'business-intro', _vm.intro, false))], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('div', {
    staticClass: "d-md-none"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/business/domestic/care/middle.jpg",
      "alt": ""
    }
  })], 1), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-card', {
    attrs: {
      "img": "/images/business/domestic/care/business.jpg",
      "color": "#FEFCFB",
      "tile": "",
      "flat": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1920 / 432
    }
  }, [_c('v-container', {
    staticClass: "h-100 py-50"
  }, [_c('v-row', {
    staticClass: "h-100",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-15"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("가장 도움이 필요한")]), _vm._v(" 아이들에게, "), _c('br'), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("가장 효과적이고 투명한 돌봄")]), _vm._v("을 제공합니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg grey-1--text"
  }, [_vm._v(" 위드캔복지재단과 함께하면, "), _c('br'), _vm._v(" 아이들이 가난과 결핍을 넘어 꿈과 희망을 키울 수 있습니다. ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)]), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("주요 프로그램")])]), _c('program-list', {
    attrs: {
      "items": _vm.programs
    }
  })], 1)], 1)]), _c('section', [_c('bottom-banner', {
    attrs: {
      "item": _vm.banner
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }